// TODO: need to move this to some other folder or something inside the UP application
import { createOrganizationsStore } from '@rtkwlf/c3-lib-organizations';
import { Pod } from '@rtkwlf/c3-lib-pods';

const organizations = createOrganizationsStore(Object.values(Pod));

export { organizations };
